<template>
	<div class="sidebar-container">
		<el-menu :default-active="activeIndex" class="el-menu-vertical-demo" @select="handleSelect" @open="handleOpen"
			@close="handleClose" background-color="#A8A481" text-color="#FFF" active-text-color="#FFF">
			<el-menu-item index="1">
				<img class="icon" src="../assets/Painter/iconE.png" />
				<span slot="title">数据仪表盘</span>
			</el-menu-item>
			<el-menu-item index="2">
				<img class="icon" src="../assets/Painter/iconD.png" />
				<span slot="title">个人信息</span>
			</el-menu-item>
			<el-menu-item index="3">
				<img class="icon" src="../assets/Painter/iconC.png" />
				<span slot="title">作品管理</span>
			</el-menu-item>
			<el-submenu index="4">
				<template slot="title">
					<img class="icon" src="../assets/Painter/iconB.png" />
					<span>我的订单</span>
				</template>
				<el-menu-item index="4-1">正常图片订单</el-menu-item>
				<el-menu-item index="4-2">定制图片订单</el-menu-item>
			</el-submenu>
			<el-menu-item index="5">
				<img class="icon" src="../assets/Painter/iconF.png" />
				<span slot="title">我的收入</span>
			</el-menu-item>
			<el-menu-item index="6">
				<img class="icon" src="../assets/Painter/iconH.png" />
				<span slot="title">超话社区</span>
			</el-menu-item>
			<el-menu-item index="7">
				<img class="icon" src="../assets/Painter/iconK.png" />
				<span slot="title">我的动态</span>
			</el-menu-item>
			<el-menu-item index="8">
				<img class="icon" src="../assets/Painter/iconL.png" />
				<span slot="title">我的聊天</span>
			</el-menu-item>
			<el-menu-item index="9">
				<img class="icon" src="../assets/Painter/iconI.png" />
				<span slot="title">我的粉丝</span>
			</el-menu-item>
			<el-menu-item index="10">
				<img class="icon" src="../assets/Painter/iconJ.png" />
				<span slot="title">我的超话</span>
			</el-menu-item>
		</el-menu>
	</div>
</template>

<script>
	export default {
		name: 'PainterSidebar',
		data() {
			return {
				activeIndex: '1',
			}
		},
		watch: {
			$route: {
				handler(to, from) {
					if (to.path == '/data-board') {
						this.activeIndex = '1'
					} else if (to.path == '/user-info') {
						this.activeIndex = '2'
					} else if (to.path == '/works' || to.path == '/piblish' || to.path == '/painter-works-details') {
						this.activeIndex = '3'
					} else if (to.path == '/painter-img-order') {
						this.activeIndex = '4-1'
					} else if (to.path == '/painter-make-order') {
						this.activeIndex = '4-2'
					} else if (to.path == '/income') {
						this.activeIndex = '5'
					} else if (to.path == '/painter-super-talk' || to.path == '/painter-super-talk-details') {
						this.activeIndex = '6'
					} else if (to.path == '/painter-updates') {
						this.activeIndex = '7'
					} else if (to.path == '/painter-chat') {
						this.activeIndex = '8'
					} else if (to.path == '/fans') {
						this.activeIndex = '9'
					} else if (to.path == '/painter-mine-talk') {
						this.activeIndex = '10'
					}
					console.log('当前路由:', to);
					console.log('之前的路由:', from);
				},
				deep: true, // 深度监听（可选）
				immediate: true // 初始化时立即触发（可选）
			}
		},
		methods: {
			handleSelect(key, keyPath) {
				console.log(keyPath)
				if (key == this.activeIndex) return
				if (key == 1) {
					this.$router.replace('/data-board')
				} else if (key == 2) {
					this.$router.replace('/user-info')
				} else if (key == 3) {
					this.$router.replace('/works')
				} else if (key == '4-1') {
					this.$router.replace('/painter-img-order')
				} else if (key == '4-2') {
					this.$router.replace('/painter-make-order')
				} else if (key == 5) {
					this.$router.replace('/income')
				} else if (key == 6) {
					this.$router.replace('/painter-super-talk')
				} else if (key == 7) {
					this.$router.replace('/painter-updates')
				} else if (key == 8) {
					this.$router.replace('/painter-chat')
				} else if (key == 9) {
					this.$router.replace('/fans')
				} else if (key == 10) {
					this.$router.replace('/painter-mine-talk')
				}
			},
			handleOpen() {

			},
			handleClose() {

			}
		}
	}
</script>

<style lang="scss" scoped>
	.sidebar-container {
		width: 2.56rem;
		padding-top: .24rem;
		background: #A8A481;
	}

	::v-deep .el-menu {
		border-right: none;

		&--inline {
			.el-menu-item {
				padding-left: .56rem !important;
			}
		}

		.is-active {
			background: #857F53 !important;
		}

		.el-submenu {
			background: unset !important;

			&__title {
				display: flex;
				align-items: center;
				width: 2.08rem;
				height: .36rem;
				padding: 0 !important;
				margin-left: .24rem;
				margin-bottom: .12rem;
				border-radius: .04rem;
				line-height: .36rem;
				font-weight: 500;
				font-size: .16rem;
				color: #FFFFFF;

				.icon {
					margin-right: .08rem;
					margin-left: .16rem;
					width: .2rem;
					height: .2rem;
				}
			}

			&__icon-arrow {
				right: .16rem;
				font-size: .12rem;
				color: #FFFFFF;
			}
		}

		.is-opened {
			background: unset !important;
		}

		&-item {
			display: flex;
			align-items: center;
			padding: 0 !important;
			margin-left: .24rem;
			margin-bottom: .12rem;
			width: 2.08rem !important;
			height: .36rem !important;
			border-radius: .04rem;
			line-height: .36rem !important;
			font-weight: 500;
			font-size: .16rem;
			color: #FFFFFF;
			min-width: unset !important;

			.icon {
				margin-right: .08rem;
				margin-left: .16rem;
				width: .2rem;
				height: .2rem;
			}
		}
	}
</style>